import React from "react";
import { IncisivoNoSelect } from "../../../../components/Dientes/IncisivoNoSelect";
import Diente from "../../../../components/Diente";
import {
  Denticion,
  aplicarCaras,
  aplicarPrestacion,
  DefaultConfig,
} from "../../../../components/ConfigDiente";
import { Modal } from "../../../../components/Modal/index";
import { useToasts } from "react-toast-notifications";
import { Puente } from "../../../../components/Puente";

import {
  noContinuarPrestacionOdontoTrx,
} from "../../../../redux/prestation/prestationActions";


import { useDispatch, useSelector } from "react-redux";
import {
  MainContainer,
  ContainerBody,
  ContainerTitle,
  ContainerTitleText,
  ContenedorCorona,
  TextArea,
  Buttons,
  LinkCancelar,
  ButtonPagar,
  ContenedorDiente,
  ContenedorDientes,
} from "./styles";

const Caras = ({ itemsOdontograma, config, faces }) => {
  const itemOdonto = aplicarCaras(itemsOdontograma[0], config, faces);
  const clase = Denticion.dientes.find(
    (item) => item.diente == itemOdonto.diente
  )?.lado;
  return (
    <>
      <ContenedorDientes>
        <ContenedorDiente>
          <Diente numero={itemOdonto.diente} config={itemOdonto} />
        </ContenedorDiente>
      </ContenedorDientes>
      <ContenedorCorona>
        <div>
          <span className="span-font">Selección de caras:</span>
        </div>
        <div className={clase}>
          <IncisivoNoSelect
            width="20rm"
            height="20rm"
            faces={faces}
            color={config.color}
          />
        </div>
      </ContenedorCorona>
    </>
  );
};

const General = ({ itemsOdontograma, config, faces }) => {
  let itemsOdonto;
  const { addToast } = useToasts();
  try {
    itemsOdonto = itemsOdontograma.map((item) =>
      aplicarPrestacion({
        itemOdonto: item,
        config,
        caras: faces,
        esPilar: true,
      })
    );
  } catch (err) {
    addToast(err.message, { appearance: "error" });
  }

  return (
    <>
      <ContenedorDientes>
        {itemsOdonto.map((it) => (
          <ContenedorDiente>
            <Diente numero={it.diente} config={it} />
          </ContenedorDiente>
        ))}
      </ContenedorDientes>
    </>
  );
};

export const NoContinuarPrestacionModal = (props) => {
  const prestacion = useSelector((state) => state.prestacion);
  const paciente = useSelector((state) => state.paciente);
  const sesion = useSelector((state) => state.sesion);
  // Safe default for faces to avoid crash if prestacion is null during initial render
  const [faces, setFaces] = React.useState(prestacion?.caras || []);
  const [pilares, setPilares] = React.useState([]);
  const dispatch = useDispatch();
  
  const [notaClinica, setNotaClinica] = React.useState("");
  const { addToast } = useToasts();

  if (!prestacion || !prestacion.config) return null;

  const { grupo, coronaTipo } = prestacion.config;

  let itemsOdontograma = new DefaultConfig();
  if (prestacion.dientes)
    itemsOdontograma = prestacion.dientes.map((d) => new DefaultConfig(d));

  const handleCloseModal = (e) => {
    setFaces([]);
    setPilares([]);
    props.handleCloseModal();
  };

  const esPilar = (id) => {
    return pilares.some((d) => d == id);
  };

  const agregaNotaFinPrestacion = (prestacion) => {
    const nota = {
      fecha: Date.now(),
      nota: notaClinica,
      especialista: sesion.usuario.email,
    };
    prestacion.notasClinicas = [nota, ...prestacion.notasClinicas];
  };
  const handleSave = () => {
    try {
      validaTerminar(prestacion);
      prestacion.fechaFin = new Date();
      agregaNotaFinPrestacion(prestacion);
      dispatch(noContinuarPrestacionOdontoTrx(prestacion));
      addToast("Operación Satisfactoria", { appearance: "success" });
      props.handleCloseModal();
    } catch (err) {
      addToast(err.message, { appearance: "error" });
    }
  };

  const validaTerminar = (prestacion) => {
    if (!notaClinica) throw new Error("Ingrese nota Clinica");
  };

  if (sesion.loading) {
    return <div>Procesando...</div>;
  } else if (sesion.error) {
    return <div>error </div>;
  } else
    return (
      <Modal isOpen={props.isOpen} onClose={handleCloseModal}>
        <React.Fragment>
          <ContainerTitle>
            <ContainerTitleText>
              {`No Continuar Prestacion: ${prestacion.tratamiento} [${
                prestacion?.dientes?.length > 0
                  ? prestacion?.dientes?.join()
                  : ""
              }]`}
            </ContainerTitleText>
            <span>
              No continuar prestacion, quiere decir que este tratamiento no se
              aplicará al Odontograma, pero si quedará guardado en la historia
              clinica del Paciente.
            </span>
          </ContainerTitle>

          <MainContainer>
            <ContainerBody>
              <div className="container-dientes-general">
                {coronaTipo !== "PUENTE" && grupo !== "CARAS" && (
                  <General
                    itemsOdontograma={itemsOdontograma}
                    config={prestacion.config}
                    faces={faces}
                  />
                )}
              </div>
              <div className="container-dientes">
                {grupo === "CARAS" && (
                  <Caras
                    itemsOdontograma={itemsOdontograma}
                    config={prestacion.config}
                    faces={faces}
                  ></Caras>
                )}

                {coronaTipo === "PUENTE" && (
                  <Puente
                    itemsOdontograma={itemsOdontograma}
                    pilares={pilares}
                    config={prestacion.config}
                    getValue={esPilar}
                  />
                )}
              </div>
            </ContainerBody>
            <ContainerTitle>
              <TextArea
                name="nota"
                rows="3"
                cols="50"
                placeholder="Motivo para no continuar con el tratamiento"
                value={notaClinica}
                onChange={(e) => setNotaClinica(e.target.value)}
              ></TextArea>
            </ContainerTitle>
            <Buttons>
              <LinkCancelar className="btn" onClick={handleCloseModal}>
                Cancelar
              </LinkCancelar>
              <ButtonPagar className="btn" onClick={handleSave}>
                Guardar
              </ButtonPagar>
            </Buttons>
          </MainContainer>
        </React.Fragment>
      </Modal>
    );
};
